import { render, staticRenderFns } from "./BtnAddProduct.vue?vue&type=template&id=7b4bc550"
import script from "./BtnAddProduct.vue?vue&type=script&lang=js"
export * from "./BtnAddProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports